import styled from 'styled-components';

export const Preview = styled.div`
  padding: var(--sizes-40);
  border-radius: var(--button-border-radius-medium);
  background: var(--color-gray-10);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 20px;
  width: 476px;
`;

export const PreviewSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
`;

export const PreviewSectionTitle = styled.span`
  text-transform: uppercase;
  color: var(--color-gray-80);
  font: var(--font-extra-small-12pt-bold-caps);
`;

const individualSpecialPreviewImageHeight = 88;
const previewImageBorderRadius = 'var(--sizes-50)';

export const IndividualSpecialPreview = styled.div<{ $height?: number }>`
  align-items: center;
  background-color: var(--color-opal-90);
  border-radius: ${previewImageBorderRadius};
  display: flex;
  min-height: ${individualSpecialPreviewImageHeight}px;
  height: ${({ $height }) => ($height ? `${$height}px` : `${individualSpecialPreviewImageHeight}px`)};
  position: relative;
  width: 100%;
  padding-top: var(--sizes-70);
  padding-bottom: var(--sizes-70);
`;

export const IndividualSpecialImageContainer = styled.div<{ $height?: number; $imageUrl: string }>`
  background-image: ${({ $imageUrl }) =>
    `linear-gradient(to right, rgba(11, 31, 50, 0.38), var(--color-opal-90)), url(${$imageUrl})`};
  background-position: center;
  background-size: cover;
  border-radius: ${previewImageBorderRadius} 0 0 ${previewImageBorderRadius};
  min-height: ${({ $height }) => ($height ? `${$height}px` : `${individualSpecialPreviewImageHeight}px`)};
  height: ${({ $height }) => ($height ? `${$height}px` : `${individualSpecialPreviewImageHeight}px`)};
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 43%;
`;

export const IndividualSpecialPreviewTextContainer = styled.div<{ $imageUrl: string }>`
  align-items: flex-start;
  background-color: var(--color-opal-90);
  border-radius: ${previewImageBorderRadius};
  display: flex;
  flex-direction: column;
  min-height: ${individualSpecialPreviewImageHeight}px;
  width: 100%;
  background-image: ${({ $imageUrl }) =>
    `linear-gradient(to right, rgba(11, 31, 50, 0.38), var(--color-opal-90)), url(${$imageUrl})`};
  background-position: center;
  background-size: cover;
  padding: var(--sizes-70);
  gap: var(--sizes-30);
  color: var(--color-grayscale-white);
  word-break: break-word;
`;

export const PreviewTitle = styled.p`
  font: var(--font-large-16pt-semibold);
`;

export const PreviewDescription = styled.p`
  font: var(--font-regular-14pt-normal);
`;

export const SpecialsCardContainer = styled.div<{ $imageUrl: string }>`
  background: ${({ $imageUrl }) =>
    `linear-gradient(180deg, rgba(11, 31, 50, 0.432) 33.75%, rgba(11, 31, 50, 0.9) 100%), url(${$imageUrl})`};
  background-size: cover;
  width: 100%;
  max-width: 337px;
  min-height: 150px;
  border-radius: ${previewImageBorderRadius};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: var(--sizes-60);
  flex: 1 0 auto;
  background-position: center left;
  padding: var(--sizes-70);
  color: var(--color-grayscale-white);
  word-break: break-word;

  &:hover {
    cursor: pointer;
    button {
      border: 2px solid var(--color-grayscale-white);
      background-color: var(--color-grayscale-white);
      color: var(--color-gray-100);
    }
  }
`;

export const SpecialsCardShopButton = styled.button`
  width: 65px;
  height: 32px;
  background: transparent;
  text-transform: uppercase;
  font: var(--font-extra-small-12pt-bold-caps);
  color: var(--color-grayscale-white);
  border: 2px solid var(--color-grayscale-white);
  border-radius: ${previewImageBorderRadius};

  &:hover {
    cursor: pointer;
  }
`;

export const RankTooltip = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sizes-40);
  width: 264px;
`;

export const RankTooltipVisual = styled.div`
  background-repeat: no-repeat;
  background-image: url('/assets/discount-wizard-display-order-tooltip.png');
  background-size: cover;
  height: 83px;
  width: 264px;
`;

export const DescriptionWithGamification = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sizes-20);
`;
